import clinicallyTestedDesktop from 'assets/images/homeRevamp/clinically-tested-desktop.jpg';
import clinicallyTestedMobile from 'assets/images/homeRevamp/clinically-tested-mobile.jpg';
import darkInfoIcon from 'assets/images/homeRevamp/dark-info-icon.svg';
import fiveStarProductReviewsDesktop from 'assets/images/homeRevamp/five-star-product-reviews-desktop.jpg';
import fiveStarProductReviewsMobile from 'assets/images/homeRevamp/five-star-product-reviews-mobile.jpg';
import videoHeroPosterDesktop from 'assets/images/homeRevamp/home-hero-video-poster-desktop.jpg';
import videoHeroPosterMobile from 'assets/images/homeRevamp/home-hero-video-poster-mobile.jpg';
import videoHeroPosterTablet from 'assets/images/homeRevamp/home-hero-video-poster-tablet.jpg';
import howItWorksImage1 from 'assets/images/homeRevamp/how-it-works-01.jpg';
import howItWorksImage2 from 'assets/images/homeRevamp/how-it-works-02.jpg';
import acai from 'assets/images/homeRevamp/ingredients/0-acai.png';
import spirulina from 'assets/images/homeRevamp/ingredients/1-spirulina.png';
import seaMoss from 'assets/images/homeRevamp/ingredients/2-sea-moss.png';
import biotin from 'assets/images/homeRevamp/ingredients/3-biotin.png';
import rosehipOil from 'assets/images/homeRevamp/ingredients/4-Rosehip-Oil.png';
import niacinamide from 'assets/images/homeRevamp/ingredients/5-niacinamide.png';
import bakuchiol from 'assets/images/homeRevamp/ingredients/6-bakuchiol.png';
import vitamineC from 'assets/images/homeRevamp/ingredients/7-vitamine-c.png';
import aminoAcids from 'assets/images/homeRevamp/ingredients/8-amino-acids.png';
import castorOil from 'assets/images/homeRevamp/ingredients/9-castor-oil.png';
import acaciaOil from 'assets/images/homeRevamp/ingredients/10-acacia-oil.png';
import aloeVera from 'assets/images/homeRevamp/ingredients/11-aloe-vera.png';
import appleCiderVinegar from 'assets/images/homeRevamp/ingredients/12-apple-cider-vinegar.png';
import coconutOil from 'assets/images/homeRevamp/ingredients/13-coconut-oil.png';
import pressAllure from 'assets/images/homeRevamp/press-allure-logo.png';
import pressCQ from 'assets/images/homeRevamp/press-cq-logo.png';
import pressElle from 'assets/images/homeRevamp/press-elle-logo.png';
import pressGlamour from 'assets/images/homeRevamp/press-glamour-logo.png';
import pressHarpersBazaar from 'assets/images/homeRevamp/press-harpers-bazaar-logo.png';
import pressVogue from 'assets/images/homeRevamp/press-vogue-logo.png';
import howItWorksImage3 from 'assets/images/homeRevamp/prose-product-testing-in-lab.jpg';
import whiteInfoIcon from 'assets/images/homeRevamp/white-info-icon.svg';

export const heroContent = {
  headline: 'Truly custom haircare and skincare',
  eyebrow: 'Made just for you',

  backgroundVideo: {
    mobile: 'home-hero-mobile',
    tablet: 'home-hero-tablet',
    desktop: 'home-hero-desktop',
  },
  backgroundVideoPosterImage: {
    mobile: videoHeroPosterMobile,
    tablet: videoHeroPosterTablet,
    desktop: videoHeroPosterDesktop,
  },
  imgAlt: 'Hair and skin trio bundle',
};

export const prosePromiseContent = {
  title: 'The Prose Promise™',
  list: [
    'Love your first order (or it’s on us)',
    '30-day free returns',
    'Free shipping for subscription orders',
    '15% off every order for subscribers',
  ],
};
export const infoIconTooltip = { dark: darkInfoIcon, white: whiteInfoIcon };

export const clinicallyTestedContent = {
  eyebrow: 'clinically tested',
  title: 'Healthier hair and skin in just 4 weeks ',
  imgAlt: 'Close-up of woman’s face with healthy hair and skin, Prose claim',
  imgMobile: clinicallyTestedMobile,
  imgDesktop: clinicallyTestedDesktop,
  tooltipContent: (
    <>
      94% of respondents agreed that Prose Shampoo + Conditioner makes their hair look healthy,
      based on self-assessment in a 4-week, double-blind, controlled clinical study of 68 subjects
      who tested Prose Shampoo + Conditioner 3 times a week. <br />
      <br />
      91% of respondents agreed that Prose Serum makes their skin feel healthy, based on a 4-week
      use test of 72 subjects aged from 25 to 70 years old with sensitive skin who tested Prose
      serum twice a day.
    </>
  ),
};

export const fiveStarProductReviewsContent = {
  title: (
    <>
      Over 500,000 5-star product reviews* <br />
      ★★★★★
    </>
  ),
  disclaimer: (
    <>
      *on Review and Refine<sup>®</sup>
    </>
  ),
  imgAlt: 'Graphic of 500,000 5-star reviews for Prose products',
  imgMobile: fiveStarProductReviewsMobile,
  imgDesktop: fiveStarProductReviewsDesktop,
};

export const tickerContent = [
  'paraben free',
  'sulfate free',
  'phthalate free',
  'free of mineral oils',
  'free of GMOs',
  'cruelty-free',
  'carbon neutral',
];

export const howItWorksContent = {
  title: 'Personalization Works Better™',
  cards: [
    {
      title: 'Take our consultation',
      description:
        'We’ll analyze 80+ factors—from what you eat to where you live—to understand the unique needs of your hair and skin.',
      imgSrc: howItWorksImage1,
      imgAlt: 'Hand holding a smartphone with Prose consultation form',
    },
    {
      title: 'Your formulas are made to order',
      description:
        'Our AI-powered algorithm personalizes your products and routine, carefully selecting from 185+ clean ingredients to meet your goals.',
      imgSrc: howItWorksImage2,
      imgAlt: 'Golden liquid being mixed for Prose custom formulations',
    },
    {
      title: 'As you change so does your Prose',
      description:
        'We’ll address any new concerns, adjust your formulas with the seasons, and learn from your feedback for an always-custom fit.',
      imgSrc: howItWorksImage3,
      imgAlt: 'Prose scientist testing products in lab',
    },
  ],
  videoId: 'TQoQtiO-ru8',
};

export const seeStoryContent = {
  dataFrom: 'brand-campaign-video',
  dataClick: 'see-the-story',
  title: 'Because beauty is personal',
  buttonText: 'see the story',
  videoId: 'kMpgNDX_Pb0',
  videoSrc: 'see-story-brand-home',
  videoSrcMobile: 'see-story-home-mobile',
};

export const pressContent = {
  title: 'Prose in the press',
  images: {
    mobile: [
      {
        key: 'vogue',
        src: pressVogue,
        alt: 'Logo of Vogue',
      },
      {
        key: 'harper',

        src: pressHarpersBazaar,
        alt: 'Logo of Harper’s Bazaar',
      },
      {
        key: 'cq',
        src: pressCQ,
        alt: 'Logo of GQ',
      },
      {
        key: 'glamour',

        src: pressGlamour,
        alt: 'Logo of Glamour',
      },
      {
        key: 'elle',
        src: pressElle,
        alt: 'Logo of Elle',
      },
      {
        key: 'allure',
        src: pressAllure,
        alt: 'Logo of Allure',
      },
    ],
    desktop: [
      {
        key: 'vogue',
        src: pressVogue,
        alt: 'Logo of Vogue',
      },
      {
        key: 'cq',
        src: pressCQ,
        alt: 'Logo of GQ',
      },
      {
        key: 'allure',
        src: pressAllure,
        alt: 'Logo of Allure',
      },
      {
        key: 'glamour',
        src: pressGlamour,
        alt: 'Logo of Glamour',
      },
      {
        key: 'elle',
        src: pressElle,
        alt: 'Logo of Elle',
      },
      {
        key: 'harper',
        src: pressHarpersBazaar,
        alt: 'Logo of Harper’s Bazaar',
      },
    ],
  },
};

export const haircareProductsGridContent = {
  sectionTitle: 'Custom haircare',
  cta: {
    labelMobile: 'shop hair',
    labelDesktop: 'shop all hair',
    path: '/products/haircare',
  },
  infoBlock: {
    eyeBrow: 'DISCOVER THE CUSTOM DIFFERENCE',
    title: '3x stronger hair',
    subtitle: '+ less breakage after just one use',
    tooltip: (
      <>
        Based on instrumental testing of Prose shampoo, conditioner and mask vs. non-conditioning
        shampoo.
      </>
    ),
  },
};

export const skincareProductsGridContent = {
  sectionTitle: 'Custom skincare',
  cta: {
    labelMobile: 'shop skin',
    labelDesktop: 'shop all skin',
    path: '/pages/skincare',
  },
  infoBlock: {
    eyeBrow: 'Dermatologist tested',
    title: '8-hr hydration',
    subtitle: '+ boosted skin firmness and elasticity',
    tooltip: (
      <>
        Based on an instrumental evaluation of 10 subjects after a single Prose moisturizer
        application.
        <br />
        <br />
        Based on a 4-week clinical study of 22 subjects with sensitive skin aged from 45 to 65 years
        old that tested Prose moisturizer twice a day.
      </>
    ),
  },
};

export const ingredientsContent = {
  titleBlock: {
    title: 'Naturally powerful ingredients',
    subtitle:
      'Your formula is uniquely yours. We target your goals with multi-benefit ingredients like:',
  },
  cta: {
    label: 'see all 185+ ingredients',
    path: '/ingredients',
  },
  sliderCardsContent: [
    {
      ingredientName: 'Hyaluronic Acid',
      description: 'to hydrate skin and support its moisture barrier',
      img: { imgSrc: acai, imgAlt: 'Hyaluronic acid for skin hydration and moisture barrier' },
    },
    {
      ingredientName: 'Sea Moss',
      description: 'to protect skin from environmental stressors like pollution ',
      img: { imgSrc: seaMoss, imgAlt: 'Sea moss extract for environmental skin protection' },
    },
    {
      ingredientName: 'Spirulina',
      description: 'to balance and refresh oily roots',
      img: { imgSrc: spirulina, imgAlt: 'Spirulina powder for balancing oily hair roots' },
    },

    {
      ingredientName: 'Biotin',
      description: 'to fortify hair strength and boost density',
      img: { imgSrc: biotin, imgAlt: 'Biotin to enhance hair strength and density' },
    },
    {
      ingredientName: 'Rosehip Oil',
      description: 'to nourish skin and promote a healthy glow',
      img: { imgSrc: rosehipOil, imgAlt: 'Rosehip oil for skin nourishment and radiance' },
    },
    {
      ingredientName: 'Niacinamide',
      description: 'to reduce the appearance of fine lines and blemishes',
      img: { imgSrc: niacinamide, imgAlt: 'Niacinamide for improving skin texture and clarity' },
    },
    {
      ingredientName: 'Bakuchiol',
      description: 'to boost skin firmness and reduce the appearance of redness',
      img: { imgSrc: bakuchiol, imgAlt: 'Bakuchiol as a natural alternative to retinol for skin' },
    },
    {
      ingredientName: 'Vitamin C',
      description: 'to help fade dark spots and fight oxidative stress',
      img: { imgSrc: vitamineC, imgAlt: 'Vitamin C for brightening and antioxidant protection' },
    },
    {
      ingredientName: 'Amino Acids',
      description: 'to mattify skin and help minimize the appearance of blemishes',
      img: { imgSrc: aminoAcids, imgAlt: 'Amino acids for hair structure and resilience' },
    },
    {
      ingredientName: 'Castor Oil',
      description: 'to nourish, soften, and add shine to hair',
      img: { imgSrc: castorOil, imgAlt: 'Castor oil for hair growth and scalp health' },
    },
    {
      ingredientName: 'Acacia Collagen',
      description: 'to repair damage and boost hair + scalp hydration',
      img: { imgSrc: acaciaOil, imgAlt: 'Acacia collagen for hair elasticity and youthfulness' },
    },
    {
      ingredientName: 'Aloe Vera',
      description: 'to soothe the scalp and support oil absorption',
      img: { imgSrc: aloeVera, imgAlt: 'Aloe vera for soothing and hydrating skin and hair' },
    },
    {
      ingredientName: 'Apple Cider Vinegar',
      description: 'to enhance shine and promote hair health',
      img: {
        imgSrc: appleCiderVinegar,
        imgAlt: 'Apple cider vinegar for scalp health and hair shine',
      },
    },
    {
      ingredientName: 'Coconut Oil',
      description: 'to help protect hair fibers from UV damage',
      img: {
        imgSrc: coconutOil,
        imgAlt: 'Coconut oil for deep hair conditioning and frizz control',
      },
    },
  ],
};

export const scienceTeamContent = {
  title: 'Backed by science, powered by people',
  description:
    'Developed by our world-class team of in-house cosmetic chemists, every Prose product is the result of rigorous research, clinical studies, and dermatologist testing.',
};
